import * as React from 'react';
import Modal from 'react-modal';

import Group from 'entities/Group';
// @ts-ignore
import GroupSelectionDialog from 'groups/components/GroupSelectionDialog';
import InvitableGroupsContainer from 'groups/containers/InvitableGroupsContainer';
// @ts-ignore
import UsersInviteModal from 'users/components/UsersInviteModal';
import ErrorReporter from 'app/components/ErrorReporter';
import LoadingModal from 'components/LoadingModal';

type Props = {
  onRequestHide: () => any;
  groups: Group[];
};

type State = {
  isInviteModalOpened: boolean;
  group?: Group | null;
};

class GroupSelectToInviteDialog extends React.Component<Props, State> {
  static defaultProps = {
    onRequestHide: () => {},
  };

  state: State = {
    isInviteModalOpened: false,
  };

  handleGroupSelect = (group: Group) => {
    this.setState({ isInviteModalOpened: true, group });
  };

  onRequestHide = () => {
    this.setState({ isInviteModalOpened: false });
    this.props.onRequestHide();
  };

  render() {
    const { group, isInviteModalOpened } = this.state;
    return (
      <React.Fragment>
        <Modal isOpen={isInviteModalOpened}>
          <UsersInviteModal group={group} onRequestHide={this.onRequestHide} />
        </Modal>
        <GroupSelectionDialog
          title="Select a class"
          groups={this.props.groups}
          onSelect={this.handleGroupSelect}
          onRequestHide={this.props.onRequestHide}
        />
      </React.Fragment>
    );
  }
}

const GroupSelectToInviteDialogContainer = (props: Props) => (
  <InvitableGroupsContainer>
    {({ groups, loading, error }) => {
      if (loading) {
        return <LoadingModal />;
      }

      if (error) {
        return (
          <ErrorReporter error="GroupSelectToInviteDialog - Failed to load invitable groups" />
        );
      }

      if (groups) {
        return <GroupSelectToInviteDialog {...props} groups={groups} />;
      }
    }}
  </InvitableGroupsContainer>
);

export { GroupSelectToInviteDialog };
export default GroupSelectToInviteDialogContainer;
